const SvgAnalytics3 = (props) => (
  <>
    <path fill={props.p30} d="M48 0h32v192H48zM144 32h32v160h-32z" />
    <path fill={props.p20} d="M0 64h32v128H0zM96 80h32v112H96z" />
  </>
);

export default SvgAnalytics3;
